import React, { useEffect, useRef, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import PaymentService from "../../services/paymentService";

export default function Payment() {
  const [scriptInnerText, setScriptInnerText] = useState<any>();
  const ref = useRef(null);
  const productEntityId: any = useQuery().get("productentityid");
  const [paymentURL, setPaymentURL] = useState<any>();
  const history = useHistory();
  useEffect(() => {
    if (productEntityId) {
      getCheckoutForm();
    }
  }, []);

  // useEffect(() => {
  //   if (scriptInnerText !== "") {
  //     const script = document.createElement("script");
  //     script.type = "text/javascript";
  //     script.innerText = scriptInnerText;
  //     document.head.appendChild(script);
  //   }
  // }, [scriptInnerText]);

  useEffect(() => {
    if (paymentURL) {
      window.location.href = paymentURL;
    }
  }, [paymentURL]);

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const getCheckoutForm = async () => {
    try {
      const response: any = await PaymentService.postProductGetCheckoutForm({
        productEntityId: productEntityId,
      });
      console.log(response);
      if (response.data.status === "success") {
        const scriptInnerText = response.data.checkoutFormContent
          .replace('<script type="text/javascript">', "")
          .replace("</script>", "");
        setPaymentURL(response.data.payWithIyzicoPageUrl);
        console.log(scriptInnerText);
        setScriptInnerText(scriptInnerText);
      }
    } catch (e: any) {}
  };

  return (
    <div>
      {/* <div id="iyzipay-checkout-form" className="responsive"></div> */}
    </div>
  );
}
